export interface User {
  id: string;
  email: string;
  name: string;
  avatar?: string;
  createdAt: string;
}

export interface BlockedActivity {
  date: string;
  count: number;
  topSites: string[];
  timeDistribution: {
    hour: number;
    blocks: number;
  }[];
}

export interface DashboardStats {
  totalBlocksToday: number;
  totalBlocksWeek: number;
  activeRules: number;
  mostBlockedSite: string;
  streakDays: number;
}

export interface ScheduleRule {
  id: string;
  site: string;
  displayName: string;
  startTime: string;
  endTime: string;
  days: WeekDay[];
  isActive: boolean;
  category: BlockCategory;
  color?: string;
  createdAt: string;
  updatedAt: string;
}

export interface PolicyScheduleFormData {
  name: string;
  policyId: string;
  startTime: string;
  endTime: string;
  daysOfWeek: number[];
  timezone: string;
  ruleType: 'block' | 'allow';
  categories: string[];
  domains: string[];
  isActive: boolean;
}

export interface CalendarEvent {
  id: string;
  title: string;
  description?: string;
  date: string;
  time: string;
  endTime?: string;
  duration?: string;
  type: 'block' | 'focus' | 'other';
  color: string;
  ruleId?: string; // Link to the schedule rule that created this event
}

export type WeekDay = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

export const WEEKDAY_MAP: Record<WeekDay, number> = {
  'sunday': 0,
  'monday': 1,
  'tuesday': 2,
  'wednesday': 3,
  'thursday': 4,
  'friday': 5,
  'saturday': 6,
};

export const WEEKDAY_NAMES: Record<number, WeekDay> = {
  0: 'sunday',
  1: 'monday',
  2: 'tuesday',
  3: 'wednesday',
  4: 'thursday',
  5: 'friday',
  6: 'saturday',
};

export type BlockCategory = 'social' | 'entertainment' | 'news' | 'shopping' | 'productivity' | 'custom';

export interface ScheduleFormData {
  site: string;
  displayName: string;
  startTime: string;
  endTime: string;
  days: WeekDay[];
  category: BlockCategory;
}
